import type ConvertToLTR from './types';

const convertToLTR: ConvertToLTR = (text) => text;

export default convertToLTR;
